window.addEventListener('load', (event) => {
  function setServiceOption() {
    const serviceOptions = document.querySelectorAll('.service-option-tab__content');
    serviceOptions.forEach((serviceOpt) => {
      let serviceCode = serviceOpt.getAttribute('id');
      let titleCode = 't1', valueCode = 'v1';

      const selects = serviceOpt.querySelectorAll('select');
      const prices = serviceOpt.querySelectorAll('.service-option__price');
      const priceDisplayed = serviceOpt.querySelector('.service-option__price--displayed')
      const savings = serviceOpt.querySelectorAll('.service-option__savings');
      const savingDisplayed = serviceOpt.querySelector('.service-option__saving--displayed')
      const descriptions = serviceOpt.querySelectorAll('.service-option__description');
      const descriptionDisplayed = serviceOpt.querySelector('.service-option__description--displayed')
      const bookings = serviceOpt.querySelectorAll('.service-option__booking');
      const modal = serviceOpt.querySelector('.service-option__modal');
      const modalTrigger = serviceOpt.querySelector('.service-option__modal-trigger');

      selects.forEach((select) => {
        select.addEventListener('change', function () {
          let option = this.options[this.selectedIndex];
          let dataCombo = option.getAttribute('data-combo');
          let comboCode; // Define comboCode here

          if (dataCombo.includes('t')) {
            titleCode = dataCombo;
          } else {
            valueCode = dataCombo;
          }
          comboCode = serviceCode + '_' + titleCode + valueCode;

          // Display values
          setData(prices, priceDisplayed, comboCode);
          setData(savings, savingDisplayed, comboCode);
          setData(descriptions, descriptionDisplayed, comboCode);
          setData(bookings, modal, comboCode, 'modal');
        })
      });

      let comboCode = serviceCode + '_' + titleCode + valueCode; // Define comboCode here

      setData(prices, priceDisplayed, comboCode);
      setData(savings, savingDisplayed, comboCode);
      setData(descriptions, descriptionDisplayed, comboCode);
      setData(bookings, modal, comboCode, 'modal');

      function setData(arr, target, comboCode, id = '') {
        arr.forEach((el) => {
          if (el.getAttribute('data-combination') == comboCode) {
            if (id == 'modal') {
              modalTrigger.setAttribute('id', id + '-' + comboCode);
              target.setAttribute('id', id + '-' + comboCode);
              target.setAttribute('data-combo', comboCode);
              // target.querySelector('iframe').setAttribute('src', el.value);
              let iframes = target.querySelectorAll('iframe');
              iframes.forEach(iframe => {
                if (iframe.classList.contains(comboCode)) {
                  iframe.style.display = 'block';
                } else {
                  iframe.style.display = 'none';
                }
              });
            } else {
              if (el.classList.contains('service-option__savings')) {
                if (el.value == 'NA' || el.value == '0' || el.value == '') {
                  target.parentElement.style.display = 'none';
                } else {
                  target.parentElement.style.display = 'flex';
                  target.innerHTML = el.value;
                }
              } else {
                target.innerHTML = el.value;
              }
            }
          }
        });
      }
      serviceOpt.classList.replace('is-loading', 'has-loaded');
    });
  }

  setServiceOption();

});
